import { Radio } from "components/common/Radio/Radio";
import { FC, ReactNode } from "react";

interface LIProps<T> {
    option: T;
    handleClick: (option: T) => void;
    getOptionValue: (option: T) => string | number;
    listItemClassNames?: string;
    isSelected?: boolean;
    getOptionLabel?: (option: T) => string;
    renderItem?: (option: T) => ReactNode;
    isMobile?: boolean;
    testKey: string;
}

export const LI = <T,>({
    option,
    handleClick,
    getOptionLabel,
    isSelected,
    getOptionValue,
    renderItem,
    listItemClassNames,
    isMobile,
    testKey,
}: LIProps<T>) => {
    return (
        <li
            value={getOptionValue(option)}
            onClick={(e) => {
                handleClick(option);
            }}
            className={`px-4 py-1 hover:bg-irGray-200 ${!!isSelected && "bg-irGray-200 dark:bg-darkSurface-100"} ${
                listItemClassNames ?? "py-5"
            } ${isMobile && `flex items-center gap-4`}`}
            data-testid={`${testKey}-option-${(getOptionValue && getOptionValue(option)) ?? ""}`}
        >
            {isMobile && (
                <div>
                    <Radio handleClick={() => handleClick(option)} value={!!isSelected} />
                </div>
            )}
            {renderItem ? renderItem(option) : getOptionLabel && getOptionLabel(option)}
        </li>
    );
};
